// extracted by mini-css-extract-plugin
var _1 = "ri22c";
var _2 = "tkUrK";
export { _1 as "content", _2 as "footer" }
